module.exports = __webpack_public_path__ + "img/starbucks-status-panel-en-small.fe7a30ad.webp";